import _ from 'lodash';
import objectAssign from 'object-assign';

export function calcTeamPrice(teams, allCategories) {
  return _.sumBy(teams, (team) => {
    let category = _.find(allCategories, {id: Number(team.team_category)});
    let price = Number(category.price);
    price += (Number(category.price_per_member) * _(team.members).filter({'_destroy': false}).size());
    return price;
  });
}

export function getTeamMemberPriceObject(teamMembers, allMemberCategories) {
  let membersPrices = {};
  _.forEach(teamMembers, (member) => {
    let memberId = member.member_reg_details.member_details.id;
    let prices = _.flatMap(member.categories, (catId) => {
      let cat = _.find(allMemberCategories, {id: catId});
      if (cat) {
        return Number(cat.price);
      } else {
        return;
      }
    });
    if (_.size(prices) > 0 && membersPrices[memberId]) {
      membersPrices[memberId].push(_.flattenDeep([prices]));
    } else if (_.size(prices) > 0) {
      membersPrices[memberId] = [prices];
    }
  });
  return membersPrices;
}

export function calcTeamMemberPrice(membersPrices, schema) {
  let uniqueMemberPrices = _.map(membersPrices, (member) => {
    return _[schema](_.flattenDeep(member));
  });
  return _.sum(uniqueMemberPrices);
}

export function calculateTeamTypePrice(reg, team) {
  let registration = objectAssign({}, reg);
  let teamType = objectAssign({}, team);
  let price = 0;
  let teams = _.filter(registration.teams, {team_type: teamType.id, _destroy: false});
  let allCategories = teamType.team_categories;

  let allMemberCategories = _.flatMap(allCategories, 'member_categories');
  let teamMembers = _(teams).flatMap('members').filter({'_destroy': false}).value();

  let membersPrices = getTeamMemberPriceObject(teamMembers, allMemberCategories);

  price += calcTeamPrice(teams, allCategories);
  price += calcTeamMemberPrice(membersPrices, teamType.member_price_scheme);
  return price;
}

export function calculateContenderPrice(reg, eventDetails) {
  let contenderCount = _.size(reg.member_registrations);
  let contenderPrice = contenderCount * (eventDetails.price_contender || 0);
  return contenderPrice;
}

export function calculatePrice(reg, teamList, eventDetails) {
  let registration = objectAssign({}, reg);
  let teamTypes = objectAssign({}, teamList);
  let price = 0;
  price += calculateContenderPrice(reg, eventDetails);
  _.forEach(teamTypes, (teamType) => {
    price += calculateTeamTypePrice(registration, teamType);
  });
  return price;
}



/** WEBPACK FOOTER **
 ** ./src/components/common/calculatePrice.js
 **/